<div class="exception-configuration h-full" id="exception-configuration-list-page">
  <ptg-breadcrumb [listBreadcrumbs]="listBreadcrumbs"></ptg-breadcrumb>

  <div class="flex flex-col p6 content-container">
    <div *ngIf="bannerType" class="p-6">
      <ptg-banner [(bannerType)]="bannerType" [message]="message"></ptg-banner>
    </div>
    <div class="grid-wrapper h-full">
      <ptg-grid
        [data]="exceptionConfigurations"
        [columns]="columns"
        [isLoading]="isLoading"
        [fitToParent]="true"
        [totalRecords]="totalRecords"
        [pageSize]="pageSize"
        [pageNumber]="pageNumber"
        (sortChange)="onChangeSort($event)"
        (pageChange)="onChangePage($event)"
        notFoundMessage="No Data to Display">
        <ng-template cellContent columnName="action" let-row>
          <ptg-button buttonName="Edit" classInput="edit-button" (clickButton)="onClickEditExceptionConfiguration(row)">
            <mat-icon>edit</mat-icon>
          </ptg-button>
        </ng-template>
      </ptg-grid>
    </div>
  </div>
</div>
